import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import AccountMenu  from '../../Modules/AccountMenu'

import OnbekendeOpleiding from '../../Modules/Kennis/Toevoegen/OnbekendeOpleiding';

class MemberOpleidingUnknownAdd extends Component {
  render() {
    return (
      <div className="route">
      <AccountMenu/>
        <div className="grey-bg">
            <h1 className="pageTitle">
                Een onbekende opleiding toevoegen
            </h1>
            <Row>
              <Col md={12}>
                <OnbekendeOpleiding />
              </Col>
            </Row>
            {/* <Bijeenkomst /> */}
        </div>
      </div>
    );
  }  
}

export default MemberOpleidingUnknownAdd;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Toevoegen/OpleidingOnbekend.js